import React from 'react';
import { Link } from 'react-router-dom';
import { PLANNERS } from './plannerConfig';
import './planner.css';

export const HexMark = ({ size = 16 }) => (
  <svg className="rb-hex" width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.2">
    <path d="M12 2l8.66 5v10L12 22l-8.66-5V7L12 2z" />
    <path d="M12 8l3.46 2v4L12 16l-3.46-2v-4L12 8z" opacity="0.5" />
  </svg>
);

export default function PlannerHome() {
  return (
    <div className="rb-planner">
      <div className="rb-home">
        <div className="rb-brand-mark"><HexMark size={20} /></div>
        <h1 data-testid="planner-home-title">Ricky's Bees</h1>
        <p className="rb-serif" style={{ fontSize: '1.2rem', fontWeight: 500, marginTop: 4 }}>Business Planner</p>
        <p className="rb-sub" style={{ marginTop: 12 }}>Plan &nbsp;•&nbsp; Produce &nbsp;•&nbsp; Pack &nbsp;•&nbsp; Grow</p>

        <div className="rb-cards">
          {PLANNERS.map(p => (
            <Link to={`/planner/${p.id}`} className="rb-card" key={p.id} data-testid={`planner-card-${p.id}`}>
              <span className="rb-num">{p.num}</span>
              <h3>{p.title}</h3>
              <p>{p.desc}</p>
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
}
